import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UsePlaceAuth } from "../../AppContext/AppContext";
import contact from "../../demo/contact-us.svg";
import blackcontact from "../../demo/black_contact-us.svg";
import axios from "axios";
import ContactModal from "../Modals/ContactModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Audio_Tour, Car_Rentals, _Deals_, _Flight_, Hotel, Restaurants, Things_to_do, _Blog_, Home, _Demo_, clearPlace } from "../../Redux/Action/Action";
import RegLoginModal from "../Modals/RegLoginModal";
import { toast } from "react-toastify";
// import Blog from "../dashboard/blog/Blog";
import logo from '../../assets/images/logo.png'

const formatUserName = (name) => {
	if (!name) return "";

	// Capitalize first letter
	const capitalized = name.charAt(0).toUpperCase() + name.slice(1);

	if (capitalized.length <= 10) return capitalized;

	const start = capitalized.slice(0, 3);
	const end = capitalized.slice(-4);

	return `${start}...${end}`;
};


function Header() {
	const place = useSelector(state => state.place);
	let { hotelUrl, setHotelUrl } = UsePlaceAuth();
	const [selectedCity, setSelectedCity] = useState("Choose City");
	const [selectedCategory, setSelectedCategory] = useState("Category");
	const navigate = useNavigate();
	const location = useLocation();
	const [regLoginModal, setRegLoginModal] = useState(false);
	const [isHover, setIsHover] = useState(false);


	let { flightUrl, setFlightUrl } = UsePlaceAuth();
	const [contactModal, SetContactModal] = useState(false);
	const CallApi = async () => {
		axios
			.get(
				`${process.env.REACT_APP_BASE_URL}hotel-url?city=${place}`,
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			)
			.then(
				function (response) {
					setHotelUrl(response?.data?.data[0].city_id_code)
				},
				(error) => {
					console.log(error);
				}
			);
		axios
			.get(
				`${process.env.REACT_APP_BASE_URL}flight-url?city=${place}`,
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			)
			.then(
				function (response) {
					setFlightUrl(response?.data?.data[0].url)
				},
				(error) => {
					console.log(error);
				}
			);
	};
	useEffect(() => {
		CallApi();
	}, [place])

	const cityCodes = {
		'Chicago': 'CHI', 'Los Angeles': 'LAX', 'San Francisco': 'SFO', 'Miami': 'MIA', 'Las Vegas':
			'LAS', 'Boston': 'BOS', 'Seattle': 'SEA', 'Dallas': 'DFW', 'Atlanta': 'ATL', 'Orlando': 'MCO', 'Philadelphia': 'PHL', 'San Diego':
			'SAN', 'New York': 'NYC', 'Nashville': 'BNA', 'Houston': 'IAH', 'New Orleans': 'MSY', 'Denver': 'DEN', 'Phoenix': 'PHX',
		'Austin': 'AUS', 'Charlotte': 'CLT', 'Tampa': 'TPA', 'Portland': 'PDX', 'Salt Lake City': 'SLC',
		'San Antonio': 'SAT', 'Minneapolis': 'MSP', 'St Louis': 'STL', 'Charleston': 'CHS', 'Savannah': 'SAV', 'Honolulu': 'HNL'
	};

	const handleMenuIcon = () => {
		if (window.screen.width < 990) {
			document.getElementById("navbarSupportedContent").classList.remove("show")
		}
		localStorage.removeItem("localFormData");
	}
	const active = useSelector(state => state.active);
	const dispatch = useDispatch();
	const [isToggled, setIsToggled] = useState(false);

	const toggleElements = () => {
		setIsToggled(!isToggled);
		localStorage.removeItem("localFormData");
	};

	const handleLogout = () => {

		localStorage.removeItem('userName');
		localStorage.removeItem('token');
		localStorage.removeItem('userData');
		localStorage.removeItem('userEmail');
		localStorage.removeItem('selectedCity');
		localStorage.removeItem('localFormData');
		localStorage.removeItem('isLoggedIn');
		setUserName(null);

	};
	const handleClick = () => {
		setRegLoginModal(true);
	};
	const [userName, setUserName] = useState(null);

	useEffect(() => {

		const storedUserName = localStorage.getItem('userName');
		if (storedUserName) {
			setUserName(storedUserName);
		}
	}, []);

	const THINGS_TO_DO_CATEGORIES = [
		"shopping",
		"day-trip",
		"museum",
		"sightseeing",
		"night-life",
		"top-attractions",
		"fine-dining",
	];

	const isThingsToDoCategory = (value = "") =>
		THINGS_TO_DO_CATEGORIES.includes(value.toLowerCase());



	// Extract the city name from any of the matching routes
	const pathPrefixes = [
		'hotel',
		'flight',
		'car-rental',
		'restaurant',
		'things-to-do',
		'experiences',
		'audio-tour',
		'deal',
		'deals',
		'sports',
		'performing-arts',
		'brewery',
		'comedy',
		'family',
		'flights',
		'vacations',
		'hotels',
		'tours',
		'cruises',
		'adventures',
		'rock',
		'blues',
		'jazz',
		'country',
		'concerts',
		'performing-arts',
		'brewery',
		'comedy',
		'family',
		'car-rental',
	];

	// Extracts the city slug from the URL if it matches a known path prefix
	const extractPlace = (pathname) => {
		const parts = pathname.split("/").filter(Boolean);

		// Handle only things-to-do specially
		if (parts[0] === "things-to-do") {
			// /things-to-do
			if (parts.length === 1) return null;

			// /things-to-do/Shopping
			if (parts.length === 2) {
				const slug = parts[1].toLowerCase();
				return THINGS_TO_DO_CATEGORIES.includes(slug) ? null : parts[1];
			}

			// /things-to-do/Shopping/austin
			if (parts.length >= 3) {
				return parts[2];
			}
		}

		// ---- default behavior for other pages ----
		for (let i = 0; i < parts.length - 1; i++) {
			if (pathPrefixes.includes(parts[i])) {
				return parts[i + 1];
			}
		}

		return null;
	};


	useEffect(() => {
		const citySlug = extractPlace(location.pathname);

		if (citySlug) {
			const decodedSlug = decodeURIComponent(citySlug).toLowerCase().replace(/\s+/g, '-');

			const matchedCity = Object.keys(cityCodes).find((cityName) => {
				const citySlugified = cityName.toLowerCase().replace(/\s+/g, '-');
				return citySlugified === decodedSlug;
			});

			if (matchedCity) {
				setSelectedCity(matchedCity);
				localStorage.setItem('selectedCity', matchedCity);
			}
		} else {
			const parts = location.pathname.split("/").filter(Boolean);

			// 🚫 Do NOT auto-restore city for things-to-do category pages
			if (
				parts[0] === "things-to-do" &&
				(parts.length === 1 || parts.length === 2)
			) {
				setSelectedCity("Choose City");
				return;
			}

			// ✅ restore city for other pages
			const stored = localStorage.getItem('selectedCity');
			setSelectedCity(stored && stored !== 'undefined' ? stored : 'Choose City');
		}
	}, [location.pathname]);

	useEffect(() => {
		if (!place) return;

		// 🚫 HARD STOP: never allow category as city
		if (isThingsToDoCategory(place)) {
			return;
		}

		const parts = location.pathname.split("/").filter(Boolean);

		// 🚫 Stop auto rewrite on category-only pages
		if (
			parts[0] === "things-to-do" &&
			parts.length === 2 &&
			isThingsToDoCategory(parts[1])
		) {
			return;
		}

		// Convert slug to Proper Name
		const formatted = place
			.replace(/-/g, " ")
			.replace(/\b\w/g, (c) => c.toUpperCase());

		// Update header city name
		setSelectedCity(formatted);
		localStorage.setItem("selectedCity", formatted);

		// -------- Update URL automatically --------
		const currentPath = location.pathname;
		const pathParts = currentPath.split("/").filter(Boolean);

		// If last part is a city, replace it
		if (pathParts.length >= 2) {
			const last = pathParts[pathParts.length - 1];

			// Replace only if city changed
			if (last !== place) {
				pathParts[pathParts.length - 1] = place;
				navigate("/" + pathParts.join("/"));
			}
		}
		// If URL has no city (like /car-rental), append the city
		else if (pathParts.length === 1) {
			navigate(`/${pathParts[0]}/${place}`);
		}
	}, [place]);

	const localSelectedCity = localStorage.getItem('selectedCity');

	return (
		<>
			<header className="header-section">
				<nav className="navbar navbar-expand-lg">
					<div className="container">
						{/* <div className="container"> */}
						{/* <Link className="navbar-brand"
							to={'/'}
							onClick={() => {
								localStorage.removeItem('selectedCity')
								localStorage.removeItem('localFormData')
								dispatch(Home())   // ✅ set active to Home
								dispatch(clearPlace());
							}}
						>
							<img src={logo} alt="logo" />
						</Link> */}
						<a className="navbar-brand"
							to={'/'}
							onClick={() => {
								localStorage.removeItem('selectedCity')
								localStorage.removeItem('localFormData')
								dispatch(Home())   // ✅ set active to Home
								dispatch(clearPlace());
								window.location.href = 'https://www.mysittivacations.com';
							}}
						>
							<img src={logo} alt="logo" />
						</a>
						<button
							className={`navbar-toggler ${isToggled ? 'show' : ''}`}
							type="button"
							onClick={toggleElements}
							aria-controls="navbarSupportedContent"
							// aria-expanded={isToggled} 
							aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className={`collapse navbar-collapse justify-content-end ${isToggled ? 'show' : ''}`} id="navbarSupportedContent">
							<ul className="navbar-nav ms-auto mb-2 mb-lg-0">

								<li
									className={
										location.pathname === "/" || location.pathname === "/home" || location.pathname.startsWith("/home")
											? "nav-item activeMenu"
											: "nav-item"
									}
									onClick={() => {
										dispatch(Home());
										toggleElements();
									}}
								>
									<a
										className="nav-link headerIconss"
										href="https://www.mysittivacations.com/"
									>
										Home
									</a>
									{/* <Link
										className="nav-link headerIconss"
										to={
											localSelectedCity && localSelectedCity !== "undefined"
												? `/home/${place}`
												: "/"
										}
									>
										Home
									</Link> */}
								</li>


								{/* <li className={active === "1" && location.pathname.startsWith("/hotel") ? "nav-item  activeMenu" : "nav-item "} onClick={() => { dispatch(Hotel()); toggleElements(); }}>
									<Link className="nav-link headerIconss" to={
										localSelectedCity && localSelectedCity !== "undefined"
											? hotelUrl
											: '/hotel'
									}>
										Hotel
									</Link>

								</li> */}
								<li className={active === "2" && location.pathname.startsWith("/flight") ? "nav-item  activeMenu" : "nav-item "} onClick={() => { dispatch(_Flight_()); handleMenuIcon() }}>
									<a className="nav-link headerIconss" href="https://travel.mysittivacations.com/?adults=1&children=0&currency=usd&depart_date=2026-03-19&destination_iata=DEN&flightSearch=IXC1903DEN21031&infants=0&marker=130544.Zzb4aa0accf8fd4d43b39445a-130544&origin_iata=IXC&return_date=2026-03-21&trip_class=0&with_request=true">
										Flight
									</a>
								</li>
								{/* <li className={active === "2" && location.pathname.startsWith("/flight") ? "nav-item  activeMenu" : "nav-item "} onClick={() => { dispatch(_Flight_()); handleMenuIcon() }}>
									<Link className="nav-link headerIconss" to={
										localSelectedCity && localSelectedCity !== "undefined"
											? flightUrl : '/flight'}>
										Flight
									</Link>
								</li> */}
								<li className={active === "3" && location.pathname.startsWith("/car-rental") ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Car_Rentals()); handleMenuIcon() }}>
									<a className="nav-link headerIconss" href="https://www.mysittivacations.com/car-rentals/">
										Car Rentals
									</a>
								</li>
								{/* <li className={active === "3" && location.pathname.startsWith("/deals") ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(_Deals_()); handleMenuIcon() }}>

									<Link className="nav-link headerIconss" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/deals/${place}` : `/deals`}>
										Deals</Link>
								</li> */}
								<li className={active === "3" && location.pathname.startsWith("/deals") ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(_Deals_()); handleMenuIcon() }}>

											<Link
										to={place ? `/things-to-do/${encodeURIComponent(place.toLowerCase())}` : "/things-to-do"}
										className="nav-link headerIconss"
									>
										Deals
									</Link>
								</li>
								{/* <li className={active === "3" && location.pathname.startsWith("/car-rental") ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Car_Rentals()); handleMenuIcon() }}>
									<Link className="nav-link headerIconss" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/car-rental/${place}` : '/car-rental'}>
										Car Rentals
									</Link>
								</li> */}
								{/* <li className={active === "4" ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Restaurants()); handleMenuIcon() }}>
									<Link to={place && localSelectedCity && localSelectedCity !== "undefined"
										? `/restaurant/${place}`
										: '/restaurant'} className="nav-link headerIconss" >
										Restaurants
									</Link>
								</li> */}
								{/* <li
									className={active === "5" ? "nav-item activeMenu" : "nav-item"}
									onClick={() => {
										dispatch(Things_to_do());
										handleMenuIcon();
									}}
								>
									<Link
										to={place ? `/things-to-do/${encodeURIComponent(place.toLowerCase())}` : "/things-to-do"}
										className="nav-link headerIconss"
									>
										Things to do
									</Link>
								</li> */}

								<li className="nav-item dropdown">
									<a className="nav-link headerIconss dropdown-toggle moreArrow" role="button" aria-label="Toggle navigation" data-bs-toggle="dropdown" aria-controls="navbarNav" aria-expanded="false">
										More
									</a>
									<ul className="dropdown-menu " style={{ width: '200px' }}>
										{/* <li className={active === "6" ? "activeMenu" : ""} onClick={() => {
											if (!localSelectedCity || localSelectedCity === "undefined") {
												toast.warning("Please select a city first");
											} dispatch(Audio_Tour()); handleMenuIcon()
										}}>
											<Link to={place && localSelectedCity && localSelectedCity !== "undefined"
												? `/audio-tour/${place}`
												: '/audio-tour'} className="dropdown-item headerIcons" >
												Audio Tour</Link>
										</li> */}
										{/* <li className={active === "7" ? "activeMenu" : ""} onClick={() => { dispatch(_Deals_()); handleMenuIcon() }}>
											<Link className="dropdown-item headerIcons" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/deals/${place}` : `/deals`}>
												Deals</Link>
										</li> */}
										<li className={active === "8" ? "activeMenu" : ""} onClick={() => { dispatch(_Blog_()); handleMenuIcon(); }}><a className="dropdown-item headerIcons" href="https://www.mysittivacations.com/blogs/">
											Blog</a>
										</li>
										{/* <li className={active === "8" ? "activeMenu" : ""} onClick={() => { dispatch(_Blog_()); handleMenuIcon(); }}><Link className="dropdown-item headerIcons" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/blog/${place}` : `/blog`}>
											Blog</Link>
										</li> */}
										{/* <li className={active === "9" ? "activeMenu" : ""} onClick={() => { dispatch(_Demo_()); handleMenuIcon(); }}><a className="dropdown-item headerIcons" href="https://travelpreferences.mysittivacations.com/">
											Travel preferences</a>
										</li> */}
										<li className={active === "9" ? "activeMenu" : ""} onClick={() => { dispatch(_Demo_()); handleMenuIcon(); }}><Link className="dropdown-item headerIcons" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/travelpreferences/${place}` : `/travelpreferences`}>
											Travel preferences</Link>
										</li>
									</ul>
								</li>
								{/* <li className="nav-item">
									{userName ? (
										<div className="dropdown">
											<Link
												className="nav-link user-name dropdown-toggle dropdown-item"
												id="userDropdown"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												<span className="loginUserIcon">

													<img loading="lazy" src={blackcontact} alt="userName" />
												</span>
												<span title={userName}> {formatUserName(userName)}</span>
											</Link>

											<ul className="dropdown-menu" aria-labelledby="userDropdown">
												<li>
													<button className="dropdown-item" onClick={handleLogout}>
														Logout
													</button>
												</li>
											</ul>
										</div>
									) : (
										<a
											onClick={handleClick}
											className="regular-btn fill-button"
											onMouseEnter={() => setIsHover(true)}
											onMouseLeave={() => setIsHover(false)}
										>
											<span>
												<img loading="lazy" src={isHover ? blackcontact : contact} alt="" />
											</span>Login
										</a>
									)}
								</li> */}
								<li className="nav-item dropdown">
									<Link
										className="regular-btn outline-btn"
										to=""
										role="button"
										aria-label="Toggle navigation"
										data-bs-toggle="dropdown"
										aria-controls="navbarNav"
										aria-expanded="false"
									>
										{selectedCategory}
									</Link>
									<ul className="dropdown-menu" style={{ maxHeight: '200px', overflowY: 'auto' }}>
										<li><a className="dropdown-item" href="https://www.mysittivacations.com/couple-travels/">
											Couple Travels</a>
										</li>
										<li><a className="dropdown-item" href="https://www.mysittivacations.com/family-travels/">
											Family Travels</a>
										</li>
										<li><a className="dropdown-item" href="https://www.mysittivacations.com/solo-travels/">
											Solo Travels</a>
										</li>
										<li><a className="dropdown-item" href="https://www.mysittivacations.com/lgbtq-travels/">
											LGBTQ Travels</a>
										</li>

									</ul>
								</li>
								<li className="nav-item dropdown">
									<Link
										className="regular-btn outline-btn"
										to=""
										role="button"
										aria-label="Toggle navigation"
										data-bs-toggle="dropdown"
										aria-controls="navbarNav"
										aria-expanded="false"
									>
										{selectedCity}
									</Link>
									<ul className="dropdown-menu" style={{ maxHeight: '200px', overflowY: 'auto' }}>
										{Object.entries(cityCodes).sort(([cityA], [cityB]) => cityA.localeCompare(cityB)).map(([city, code]) => (
											<li key={code}>
												<a className="dropdown-item" onClick={() => {
													setSelectedCity(city);
													window.location.href = `https://www.mysittivacations.com/destinations/${city.toLowerCase()}/`;
													localStorage.setItem('selectedCity', city);
													// window.location.reload();

												}}>
													{city}
												</a>
											</li>
											// <li key={code}>
											// 	<Link className="dropdown-item" onClick={() => {
											// 		setSelectedCity(city);
											// 		navigate(`/experiences/${city.toLowerCase()}`);
											// 		localStorage.setItem('selectedCity', city);
											// 		window.location.reload();
											// 	}}>
											// 		{city}
											// 	</Link>
											// </li>
										))}
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</header>
			{contactModal && <ContactModal contactModal={contactModal} SetContactModal={SetContactModal} />}
			{regLoginModal && (
				<RegLoginModal
					regLoginModal={regLoginModal}
					setRegLoginModal={setRegLoginModal}
				/>
			)}

		</>
	);
	
}
export default Header;
